/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import { createSelector } from "reselect";
import { selectItems as selectLinesAggs } from "../../LinesAggs/selectors";
import { selectSurveys } from "../../../../AppAnalysisPage/selectors/surveys";

/**
 * HELPERS
 */

const filterSurveys = (job, surveysIdMap) => {
	const surveys = job.surveys.filter(s => s.externalId && !surveysIdMap[s.externalId]);
	return surveys;
}

const filterJobs = (jobs = [], surveysIdMap) => {
	const _jobs = [];
	jobs.forEach(j => {
		const _j = { ...j };
		_j.surveys = filterSurveys(_j, surveysIdMap);
		if (_j.surveys && _j.surveys.length) {
			_jobs.push(_j);
		}
	})
	return _jobs;
}

const selectLinesAggsSansLocalSurveys = createSelector(
	selectLinesAggs,
	selectSurveys,
  (
    linesAggs,
    surveys,
	) => {
		if (!surveys || !surveys.length) { 
			return linesAggs;
		}
		const surveysIdMap = (surveys || []).map(s => s?.survey_guid).filter(v => v).reduce((acc, guid) => { 
			acc[guid] = true;
			return acc;
		}, {})
		const filteredLines = [];
		linesAggs.forEach(la => {
			const clone = { ...la };
			clone.jobs = filterJobs(clone.jobs, surveysIdMap);
			if (clone.jobs && clone.jobs.length) {
				filteredLines.push(clone);
			}
		})
		return filteredLines;
  });

export { 
  selectLinesAggsSansLocalSurveys
}

export default {
  selectLinesAggsSansLocalSurveys
}
